module.exports = __webpack_public_path__ + "img/logo.72589bfc.png";